module.exports = __webpack_public_path__ + "static/media/downloadAndroid.59244888.svg";